/* tslint:disable */
/* eslint-disable */
/**
 * The Maritime Resource Registry API
 * The Maritime Resource Registry can be used to create and query resources that are identified by an MRN
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * Object representing the result of a namespace syntax creation
 * @export
 * @interface SyntaxCreationResult
 */
export interface SyntaxCreationResult {
    /**
     * The status of the creation
     * @type {string}
     * @memberof SyntaxCreationResult
     */
    code?: SyntaxCreationResultCodeEnum;
    /**
     * The MRN namespace of the created syntax
     * @type {string}
     * @memberof SyntaxCreationResult
     */
    namespace?: string;
    /**
     * A regular expression generated from the created syntax
     * @type {string}
     * @memberof SyntaxCreationResult
     */
    regex?: string;
    /**
     * An error message that is set if the creation results in an error
     * @type {string}
     * @memberof SyntaxCreationResult
     */
    message?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SyntaxCreationResultCodeEnum {
    CREATING = 'CREATING',
    ERROR = 'ERROR',
    OK = 'OK'
}

